import { handleActions } from 'redux-actions'

import * as rawActions from '../actions'

const defaultState = {}

export default handleActions(
  {
    [rawActions.setTenantForSharing](state, action) {
      return action.payload
    },
    [rawActions.resetShareSessionDialog](state, action) {
      return defaultState
    },
    [rawActions.resetState](state, action) {
      return defaultState
    },
  },
  defaultState
)
